import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import config from "@/configs";

const firebaseConfig = {
  apiKey: config?.firebase.apiKey,
  authDomain: `${config?.firebase.projectId}.firebaseapp.com`,
  projectId: config?.firebase.projectId,
  storageBucket: `${config?.firebase.projectId}.appspot.com`,
  messagingSenderId: config?.firebase.messagingSenderId,
  appId: config?.firebase.appId,
};

initializeApp(firebaseConfig);

if (config?.firebase.authEmulator) {
  const auth = getAuth();
  connectAuthEmulator(auth, config?.firebase.authEmulator);
}
